import { Blogs } from "../../types/Page";
import '../../../styles/HomePageBlogs.scss';
import { IMAGE_URL } from "../../../path";
import {useNavigate} from "react-router-dom";

interface HomePageBlogsProps {
    blogs: Blogs[];
}

function HomePageBlogs({ blogs }: HomePageBlogsProps) {
    const navigate = useNavigate();
    return (
        <div className="home-page-blogs-section">

            <div className="home-page-blogs-layout">

                {/* =====================================================
                    LEFT COLUMN
                ====================================================== */}

                <div className="home-page-blogs-left">

                    <div className="safari-copy-wrapper">

                        <div className="theres-a-safari">

                            <svg
                                id="Layer_1"
                                data-name="Layer 1"
                                xmlns="http://www.w3.org/2000/svg"
                                width="383.963"
                                height="511.725"
                                viewBox="0 0 383.963 511.725"
                            >
                                <g id="Group_185" data-name="Group 185">

                                    <path
                                        id="Path_490"
                                        data-name="Path 490"
                                        d="M383.963,303.749V0L281.815,24.184v-.192l-39.032,9.244v-.084L0,90.62V394.294l9.495-2.25v.084l102.5-24.259v.184l39.032-9.244v.084Z"
                                    />

                                    <path
                                        id="Path_491"
                                        data-name="Path 491"
                                        d="M0,462.9V584.605l72.167-138.8Z"
                                        transform="translate(0 -72.881)"
                                    />

                                    <path
                                        id="Path_492"
                                        data-name="Path 492"
                                        d="M150.281,144.607l-5.471,1.3.268-3.907L160.57,138.3l-.268,3.907-5.471,1.313-1.874,27.5L148.4,172.1Z"
                                        transform="translate(-23.673 -22.609)"
                                        fill="#fff"
                                    />

                                    <path
                                        id="Path_493"
                                        data-name="Path 493"
                                        d="M166.1,136.9l4.559-1.087-.87,12.657,6.24-1.489.862-12.665,4.559-1.087-2.141,31.4-4.559,1.087,1.021-14.865-6.24,1.489-1.021,14.873-4.551,1.087Z"
                                        transform="translate(-26.804 -21.78)"
                                        fill="#fff"
                                    />

                                    <path
                                        id="Path_494"
                                        data-name="Path 494"
                                        d="M201.072,145.1l-7.529,1.8-.745,10.833,8.625-2.058-.853,4.015L187.98,162.7l2.15-31.411,12.5-2.986-.268,3.907-7.947,1.9-.611,8.917,7.529-1.8Z"
                                        transform="translate(-30.731 -20.974)"
                                        fill="#fff"
                                    />

                                    <path
                                        id="Path_495"
                                        data-name="Path 495"
                                        d="M212.694,139.452l1.631-.393c2.961-.711,4-2.225,4.224-5.613l.084-1.213c.176-2.61-.385-4.032-3.538-3.279l-1.715.41-.686,10.08Zm-.234,3.513-.979,14.3-4.551,1.087,2.141-31.4,6.7-1.6c5.136-1.23,7.83.059,7.453,5.521l-.092,1.3c-.309,4.592-2.334,6.5-3.907,7.4,2,.318,2.978,1.456,2.694,5.688a76.809,76.809,0,0,0-.335,9.587l-4.408,1.054c-.309-1.815.134-7.044.284-9.294.268-3.932-.234-4.793-3.4-4.032l-1.589.376Z"
                                        transform="translate(-33.829 -20.423)"
                                        fill="#fff"
                                    />

                                    <path
                                        id="Path_496"
                                        data-name="Path 496"
                                        d="M242.333,135.237l-7.529,1.8-.736,10.833,8.616-2.058-.853,4.015-12.581,3,2.141-31.4L243.9,118.44l-.268,3.907-7.955,1.9-.6,8.917,7.529-1.8Z"
                                        transform="translate(-37.478 -19.362)"
                                        fill="#fff"
                                    />

                                    <g
                                        id="Group_182"
                                        data-name="Group 182"
                                        transform="translate(64.103 88.069)"
                                    >

                                        <path
                                            id="Path_497"
                                            data-name="Path 497"
                                            d="M249.25,126.637a54.732,54.732,0,0,0,2.25-11.251l4.166-1a39.556,39.556,0,0,1-3.028,11.435l-3.388.811Z"
                                            transform="translate(-104.85 -106.769)"
                                            fill="#fff"
                                        />

                                        <path
                                            id="Path_498"
                                            data-name="Path 498"
                                            d="M262.239,136.108,262.114,138c-.176,2.6.627,3.8,2.786,3.288,2.208-.527,3.037-2.418,3.212-5.044.243-3.505-.5-4.509-3.94-6.274-3.463-1.782-5.262-2.978-4.944-7.621.276-4.074,1.882-8.415,7.671-9.787,5.755-1.364,6.625,2.075,6.374,5.722l-.109,1.589-4.517,1.079.1-1.472c.159-2.367-.2-3.731-2.183-3.254-1.966.468-2.585,2.183-2.744,4.425-.167,2.518.284,3.48,3.179,4.843,4.693,2.225,6.09,3.8,5.739,9.034-.3,4.434-2.133,8.942-8.215,10.4-5.948,1.422-7.244-1.748-6.96-5.889l.125-1.84,4.551-1.087Z"
                                            transform="translate(-106.203 -106.42)"
                                            fill="#fff"
                                        />

                                        <path
                                            id="Path_499"
                                            data-name="Path 499"
                                            d="M296.681,123.993c-.544-5.772-.979-10.766-1.113-13.987l-.176.042c-.31,2.551-1.882,9.687-3,14.965l4.291-1.029Zm-5.145,5.036-1.991,9.411-4.626,1.1,7.654-32.725,6.45-1.539,3.589,30.031-4.76,1.138-.887-8.725-5.429,1.3Z"
                                            transform="translate(-110.681 -105.28)"
                                            fill="#fff"
                                        />

                                        <path
                                            id="Path_500"
                                            data-name="Path 500"
                                            d="M80.419,359.4,76.63,329.419l4.919-1.179,1.087,12.849c.343,4.141.853,8.775.929,12.163l.084-.017c.519-3.363,1.74-8.44,2.635-12.908l2.869-13.895,4.869-1.163-8,32.8-5.6,1.338Z"
                                            transform="translate(-76.63 -141.244)"
                                            fill="#fff"
                                        />

                                    </g>

                                    <path
                                        id="Path_501"
                                        data-name="Path 501"
                                        d="M104.682,323.2l-2.141,31.4L97.99,355.69l2.142-31.4Z"
                                        transform="translate(-16.019 -52.837)"
                                        fill="#fff"
                                    />

                                    <path
                                        id="Path_502"
                                        data-name="Path 502"
                                        d="M109.17,352.5l2.141-31.4,5.329-1.271c1.213,4.643,4.459,19.516,4.768,21.448l.067-.017c.05-3.957.318-8.374.669-13.518l.636-9.386,4.233-1.012-2.141,31.4-5.136,1.23c-1.062-4.325-4.551-20.453-4.894-22.159l-.05.017c-.017,3.739-.31,8.307-.694,13.962l-.661,9.7-4.266,1.021Z"
                                        transform="translate(-17.847 -51.878)"
                                        fill="#fff"
                                    />

                                    <path
                                        id="Path_503"
                                        data-name="Path_503"
                                        d="M146.7,329.207l-7.529,1.8-.736,10.841,8.616-2.066L146.2,343.8l-12.581,3.011,2.141-31.4,12.506-2.995L148,316.317l-7.955,1.9-.6,8.917,7.529-1.8Z"
                                        transform="translate(-21.844 -51.073)"
                                        fill="#fff"
                                    />

                                    <g
                                        id="Group_183"
                                        data-name="Group 183"
                                        transform="translate(127.824 249.356)"
                                    >

                                        <path
                                            id="Path_504"
                                            data-name="Path 504"
                                            d="M167.657,338.764l-3.572.853a20.167,20.167,0,0,1-.092-2.443,7.258,7.258,0,0,1-5.262,4.158c-4.869,1.163-6.232-1.74-5.872-6.943l1.037-15.158c.351-5.136,2.786-9.177,8.315-10.5,6.625-1.581,7.211,2.643,6.96,6.274l-.067.929-4.551,1.087.075-1.1c.125-1.882,0-3.99-2.694-3.346-2.1.5-3.154,2.024-3.354,4.977l-1.1,16.111c-.184,2.761.527,4.158,2.669,3.639,2.627-.627,3.313-2.894,3.555-6.45l.326-4.76-3.3.795.251-3.639,7.872-1.882-1.188,17.391Z"
                                            transform="translate(-152.805 -299.772)"
                                            fill="#fff"
                                        />

                                        <path
                                            id="Path_505"
                                            data-name="Path 505"
                                            d="M185.793,321.613c-.544-5.772-.979-10.766-1.113-13.987l-.176.042c-.31,2.551-1.882,9.687-3,14.965l4.291-1.029Zm-5.136,5.036-1.991,9.411-4.626,1.1,7.654-32.725,6.45-1.539,3.589,30.031-4.76,1.138-.887-8.725-5.429,1.3Z"
                                            transform="translate(-156.276 -298.874)"
                                            fill="#fff"
                                        />

                                        <path
                                            id="Path_506"
                                            data-name="Path 506"
                                            d="M204.152,312.612l1.631-.393c2.961-.711,4-2.217,4.224-5.613l.084-1.213c.176-2.61-.385-4.032-3.538-3.279l-1.715.41-.686,10.08Zm-.243,3.513-.979,14.3-4.551,1.087,2.141-31.4,6.7-1.6c5.136-1.23,7.83.059,7.453,5.521l-.092,1.3c-.31,4.592-2.334,6.5-3.907,7.4,2,.318,2.978,1.456,2.694,5.688a78.6,78.6,0,0,0-.343,9.587l-4.408,1.054c-.309-1.815.134-7.044.284-9.294.268-3.932-.234-4.785-3.413-4.032l-1.589.376Z"
                                            transform="translate(-160.255 -298.087)"
                                            fill="#fff"
                                        />

                                    </g>

                                    <path
                                        id="Path_507"
                                        data-name="Path 507"
                                        d="M230.67,292.71l12.631-3.02-.268,3.907-8.081,1.932-.619,9.085L242,302.782l-.268,3.907-7.663,1.832-.987,14.505-4.559,1.087Z"
                                        transform="translate(-37.358 -47.358)"
                                        fill="#fff"
                                    />

                                    <g
                                        id="Group_184"
                                        data-name="Group 184"
                                        transform="translate(206.786 234.968)"
                                    >

                                        <path
                                            id="Path_508"
                                            data-name="Path 508"
                                            d="M252.947,295.085l-1.1,16c-.2,2.995.878,4.015,2.936,3.53,2.192-.527,3.329-2.016,3.547-5.178l1.087-15.919c.192-2.844-.7-4.082-2.97-3.538-2.125.51-3.3,2.125-3.505,5.1m11.092-2.317L263,307.926c-.393,5.805-3.221,9.252-8.683,10.557-5.412,1.3-7.453-1.163-7.077-6.726l1.037-15.241c.393-5.73,3.58-9.21,8.533-10.4,5.094-1.221,7.6,1.062,7.219,6.65"
                                            transform="translate(-247.198 -281.69)"
                                            fill="#fff"
                                        />

                                        <path
                                            id="Path_509"
                                            data-name="Path 509"
                                            d="M276.1,295.412l1.631-.393c2.961-.711,4-2.225,4.224-5.613l.084-1.213c.176-2.61-.385-4.032-3.538-3.279l-1.715.41L276.1,295.4Zm-.243,3.513-.979,14.3-4.551,1.087,2.141-31.4,6.7-1.6c5.136-1.23,7.83.059,7.453,5.521l-.084,1.3c-.318,4.592-2.334,6.491-3.907,7.4,2,.318,2.978,1.456,2.694,5.688a76.808,76.808,0,0,0-.335,9.586l-4.408,1.054c-.31-1.815.134-7.044.284-9.294.268-3.932-.234-4.785-3.4-4.032l-1.589.376Z"
                                            transform="translate(-250.98 -280.887)"
                                            fill="#fff"
                                        />

                                    </g>

                                    <path
                                        id="Path_510"
                                        data-name="Path 510"
                                        d="M305.271,278.669l-5.471,1.313.268-3.907,15.492-3.706-.268,3.907-5.471,1.3-1.874,27.5-4.559,1.1Z"
                                        transform="translate(-49.011 -44.527)"
                                        fill="#fff"
                                    />

                                    <path
                                        id="Path_511"
                                        data-name="Path 511"
                                        d="M321.091,270.964l4.551-1.087-.862,12.657,6.24-1.489.862-12.657,4.559-1.087-2.15,31.4-4.551,1.087,1.012-14.873-6.232,1.489L323.5,301.279l-4.551,1.087Z"
                                        transform="translate(-52.142 -43.698)"
                                        fill="#fff"
                                    />

                                    <path
                                        id="Path_512"
                                        data-name="Path 512"
                                        d="M352.431,281.783c-.544-5.772-.979-10.766-1.113-13.987l-.176.042c-.31,2.551-1.882,9.687-3,14.965l4.291-1.029Zm-5.145,5.036L345.3,296.23l-4.626,1.1,7.654-32.725,6.45-1.539,3.589,30.031-4.76,1.138-.887-8.725-5.429,1.3Z"
                                        transform="translate(-55.692 -43.007)"
                                        fill="#fff"
                                    />

                                    <path
                                        id="Path_513"
                                        data-name="Path 513"
                                        d="M367.681,263.749l-5.471,1.313.268-3.907,15.492-3.706-.259,3.907-5.479,1.3-1.874,27.5-4.559,1.1Z"
                                        transform="translate(-59.214 -42.088)"
                                        fill="#fff"
                                    />

                                    <path
                                        id="Path_514"
                                        data-name="Path 514"
                                        d="M331.636,140.54a2.809,2.809,0,0,0-2.451-.468l-8.2,1.907a4.517,4.517,0,0,0-3.413,4.141l-.77,80.49a2.675,2.675,0,0,0,2.76,2.836,3.741,3.741,0,0,0,.795-.092l8.2-1.907a4.386,4.386,0,0,0,3.3-4.116l.77-80.49a2.837,2.837,0,0,0-.987-2.3m-39.425,22.645a3.973,3.973,0,0,0-2.576-.761,12.643,12.643,0,0,0-2.786.376l-4.4,1.021c-.385.092-.845.636-.8.954l-.251,24.769a.438.438,0,0,0,.151.368.443.443,0,0,0,.393.092l4.392-1.021c6.232-1.447,8.056-4.818,8.114-15.032.042-6.349-.611-9.469-2.242-10.774M299.154,197l9.645,31.7a3.375,3.375,0,0,1-2.468,3.907l-7.955,1.849a3.5,3.5,0,0,1-4.358-2.3l-8.273-29.872a.712.712,0,0,0-.92-.535l-2.735.636a1.47,1.47,0,0,0-.92,1.079l-.3,31.713a4.36,4.36,0,0,1-3.288,4.107l-8.315,1.932a3.27,3.27,0,0,1-.795.092,2.675,2.675,0,0,1-2.761-2.836l.77-80.49a4.517,4.517,0,0,1,3.413-4.141l19.248-4.475c6.517-1.514,11.293-.962,14.606,1.69,4.024,3.221,5.772,9.386,5.688,19.984-.142,13.058-2.585,19.282-9.67,24.677-.552.326-.8.887-.6,1.272m-62.087-11.469-5.153,32.666a.5.5,0,0,0,.151.393.292.292,0,0,0,.276.059l8.2-1.907a1.144,1.144,0,0,0,.644-.527.432.432,0,0,0,.067-.309l-4.183-30.374ZM259.6,240.036a3.851,3.851,0,0,1-2.811,4.082l-7.721,1.8a3.484,3.484,0,0,1-2.761-.485,3,3,0,0,1-1.271-2.083l-1.782-13.334c0-.234-.042-.351-.142-.435a.619.619,0,0,0-.527-.092l-12,2.786a1.32,1.32,0,0,0-1.037,1.087l-2.141,14.288a5.079,5.079,0,0,1-3.647,4.132l-7.721,1.8a3.1,3.1,0,0,1-.669.075,2.463,2.463,0,0,1-1.7-.652,2.56,2.56,0,0,1-.711-2.351l14.79-83.744a5.454,5.454,0,0,1,3.881-4.174l10.816-2.51a3.272,3.272,0,0,1,2.635.452,3.016,3.016,0,0,1,1.28,2.141l13.25,77.211ZM193.4,185l18.889-4.392a4.519,4.519,0,0,0,3.413-4.149v-6.45a2.664,2.664,0,0,0-3.438-2.769L180.9,174.536a4.509,4.509,0,0,0-3.413,4.141l-.77,80.49A2.686,2.686,0,0,0,179.489,262a3.743,3.743,0,0,0,.795-.092l8.315-1.932a4.349,4.349,0,0,0,3.288-4.107l.368-33.971a1.159,1.159,0,0,1,.8-.954l13.066-3.037a4.517,4.517,0,0,0,3.413-4.141v-6.332a2.759,2.759,0,0,0-.979-2.3,2.827,2.827,0,0,0-2.459-.468L193.033,207.7a.593.593,0,0,1-.519-.134.389.389,0,0,1-.142-.326l.226-21.181a1.3,1.3,0,0,1,.795-1.046m-45.431,21.206-5.153,32.666a.505.505,0,0,0,.151.393.292.292,0,0,0,.276.059l8.2-1.907a1.094,1.094,0,0,0,.644-.527.432.432,0,0,0,.067-.309l-4.183-30.374Zm22.519,54.533a3.857,3.857,0,0,1-2.819,4.082l-7.721,1.8a3.484,3.484,0,0,1-2.761-.485,3,3,0,0,1-1.272-2.083l-1.782-13.326c0-.234-.042-.351-.142-.435a.619.619,0,0,0-.527-.092l-12,2.786a1.32,1.32,0,0,0-1.037,1.087l-2.15,14.288a5.068,5.068,0,0,1-3.647,4.132L126.9,274.3a3.1,3.1,0,0,1-.669.075,2.428,2.428,0,0,1-1.69-.652,2.585,2.585,0,0,1-.719-2.351l14.79-83.752a5.454,5.454,0,0,1,3.881-4.174l10.816-2.51a3.305,3.305,0,0,1,2.635.452,3.016,3.016,0,0,1,1.28,2.141l13.25,77.211Zm-49.187-5.939A27.868,27.868,0,0,1,99.535,282.1a25.02,25.02,0,0,1-5.7.694,15.324,15.324,0,0,1-9.821-3.179c-3.9-3.129-6.015-8.491-5.948-15.091l.059-5.989a4.378,4.378,0,0,1,3.288-4.116l7.244-1.681a2.961,2.961,0,0,1,2.568.5,2.715,2.715,0,0,1,.987,2.242l-.084,4.919c-.05,3.831.7,6.391,2.225,7.621,1.154.929,2.836,1.146,4.994.644,3.313-.77,7.261-3.053,7.253-9.57.142-7.512-5.2-11.41-11.962-16.346l-.811-.594c-6.257-4.676-14.823-11.076-14.748-24.117.117-10.314,5.73-22.6,21.164-26.191,6.232-1.447,11.142-.786,14.581,1.974,3.915,3.145,5.856,8.968,5.764,17.308l.017,2.861a4.064,4.064,0,0,1-2.986,3.689l-8.315,1.932a2.365,2.365,0,0,1-1.991-.41,2.291,2.291,0,0,1-.887-1.748l.033-2.535c.1-4.952-.619-7.98-2.217-9.269a4.436,4.436,0,0,0-3.982-.544c-4.091.954-6.55,4.383-6.575,9.177-.075,6.45,4.693,10.13,11.9,15.71l.117.092c9.118,6.993,15.576,12.857,15.559,24.753"
                                        transform="translate(-12.763 -22.884)"
                                        fill="#fff"
                                    />

                                </g>
                            </svg>

                        </div>

                        <div className="home-page-blogs-copy">
                            <p>
                                From kitchen counter to cleaning cupboard
                                South Africa’s most trusted vinegar brand,
                                reimagined for modern living.
                            </p>
                        </div>

                    </div>

                    <button className="view-all-hacks" onClick={() => {
                        navigate('/news')
                    }}>
                        View All Hacks
                    </button>

                </div>


                {/* =====================================================
                    RIGHT COLUMN
                ====================================================== */}

                <div className="home-page-blogs-right">

                    <div className="home-page-blogs-right-content">

                        <div className="home-page-blogs-grid">

                            {blogs.map((blog) => (
                                <article
                                    className="home-page-blog-card"
                                    key={blog.id}
                                >

                                    <div className="home-page-blog-image">

                                        <img
                                            src={`${IMAGE_URL}/${blog.preview_image}`}
                                            alt={blog.title}
                                        />

                                    </div>


                                    {blog.category?.icon && (
                                        <div className="home-page-blog-category-icon">
                                            <img
                                                src={`${IMAGE_URL}/${blog.category.icon}`}
                                                alt={blog.category.name}
                                            />
                                        </div>
                                    )}


                                    <div className="home-page-blog-content">

                                        <div className="home-page-blog-read-time">
                                            {blog.read_time} min read
                                        </div>

                                        <h3>
                                            {blog.title}
                                        </h3>

                                        <p>
                                            {blog.subtitle}
                                        </p>

                                        <a
                                            href={`/blog/${blog.slug}`}
                                            className="home-page-blog-read-more"
                                        >
                                            Read More
                                        </a>

                                    </div>

                                </article>
                            ))}

                        </div>

                    </div>

                </div>

            </div>

        </div>
    );
}

export default HomePageBlogs;
